import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { API_BASE_URL } from "../config";

const Wishlist = () => {
    const storedUser = JSON.parse(localStorage.getItem("user") || "{}");
    const userId = storedUser?.userId || 0;
    const companyId = storedUser?.companyId || 0;

    const [wishlist, setWishlist] = useState([]);
    const [loading, setLoading] = useState(true);
    // FIX: track per-item removal in flight so the ❌ can't be double-clicked
    // before the first DELETE request resolves.
    const [removingIds, setRemovingIds] = useState(new Set());
    const navigate = useNavigate();

    // ==========================
    // LOAD WISHLIST
    // ==========================
    const loadWishlist = async () => {
        if (!companyId) {
            setLoading(false);
            return;
        }

        try {
            setLoading(true);
            const res = await fetch(
                `${API_BASE_URL}/order/GetWishlist?userId=${userId}&CompanyId=${companyId}`
            );
            if (!res.ok) {
                console.error("Failed to load wishlist:", res.status);
                return;
            }
            const data = await res.json();
            setWishlist(Array.isArray(data) ? data : []);
        } catch (err) {
            console.error("Failed to load wishlist", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadWishlist();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userId]);

    // ==========================
    // REMOVE WISHLIST
    // ==========================
    const removeWishlist = async (wishlistId) => {
        // FIX: guard against double-clicking the same item while its
        // removal request is still in flight.
        if (removingIds.has(wishlistId)) return;

        setRemovingIds((prev) => new Set(prev).add(wishlistId));

        try {
            // FIX: RemoveWishlist requires UserID + CompanyId to scope the
            // delete to the owning user — WishlistID alone was rejected
            // (or, worse, would let anyone delete any row without this check).
            const res = await fetch(
                `${API_BASE_URL}/order/RemoveWishlist?WishlistID=${wishlistId}&UserID=${userId}&CompanyId=${companyId}`,
                { method: "DELETE" }
            );

            if (!res.ok) {
                console.error("Remove wishlist failed:", res.status);
                return;
            }

            const data = await res.json();
            if (data?.success) {
                setWishlist((prev) =>
                    prev.filter((item) => item.wishlistID !== wishlistId)
                );
            }
        } catch (err) {
            console.error("Remove wishlist failed", err);
        } finally {
            setRemovingIds((prev) => {
                const next = new Set(prev);
                next.delete(wishlistId);
                return next;
            });
        }
    };

    return (
        <div className="home">
            <div id="page" className="hfeed page-wrapper">
                <Header />

                <div id="site-main" className="site-main">
                    <div id="main-content" className="main-content">
                        <div id="primary" className="content-area">

                            {/* PAGE TITLE */}
                            <div
                                id="title"
                                className="page-title"
                                style={{ background: "none", padding: "100px 0" }}
                            >
                                <div className="section-container">
                                    <div className="content-title-heading">
                                        <h1 className="text-title-heading">Wishlist</h1>
                                    </div>
                                </div>
                            </div>

                            {/* CONTENT */}
                            <div
                                id="content"
                                className="site-content"
                                role="main"
                                style={{ paddingBottom: "100px" }}
                            >
                                <div className="section-padding">
                                    <div className="section-container p-l-r">
                                        <div className="shop-wishlist">
                                            <div className="wishlist-cards">

                                                {loading ? (
                                                    <p className="empty-text">Loading...</p>
                                                ) : wishlist.length > 0 ? (
                                                    wishlist.map((item) => {
                                                        const metal = item.metalName || "";
                                                        const shape = item.shape || "";
                                                        // FIX: carry the exact wishlisted variant's
                                                        // ProductCode through to the detail page, so it
                                                        // hydrates the same carat/size instead of
                                                        // defaulting to the shape's first option.
                                                        const productCode = item.productCode || "";
                                                        const isRemoving = removingIds.has(item.wishlistID);

                                                        return (
                                                            <div
                                                                key={item.wishlistID}
                                                                className="wishlist-card"
                                                            >
                                                                {/* REMOVE */}
                                                                <button
                                                                    className="remove-btn"
                                                                    onClick={() =>
                                                                        removeWishlist(item.wishlistID)
                                                                    }
                                                                    disabled={isRemoving}
                                                                    style={{
                                                                        opacity: isRemoving ? 0.5 : 1,
                                                                        cursor: isRemoving ? "not-allowed" : "pointer",
                                                                    }}
                                                                >
                                                                    ❌
                                                                </button>

                                                                {/* IMAGE */}
                                                                <img
                                                                    src={item.productImage}
                                                                    className="wishlist-img"
                                                                    alt={item.productName}
                                                                />

                                                                {/* INFO */}
                                                                <div className="wishlist-info">
                                                                    <h2>{item.productName}</h2>

                                                                    <p className="price">
                                                                        {item.metalName}

                                                                    </p>
                                                                    <p className="price">
                                                                        {item.shape}

                                                                    </p>
                                                                    {/* VIEW */}
                                                                    <button
                                                                        className="view-btn"
                                                                        onClick={() =>
                                                                            navigate(
                                                                                `/productdetails/${item.productID}?metal=${encodeURIComponent(
                                                                                    metal
                                                                                )}${
                                                                                    shape
                                                                                        ? `&shape=${encodeURIComponent(shape)}`
                                                                                        : ""
                                                                                }${
                                                                                    productCode
                                                                                        ? `&productCode=${encodeURIComponent(productCode)}`
                                                                                        : ""
                                                                                }`
                                                                            )
                                                                        }
                                                                    >
                                                                        View
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        );
                                                    })
                                                ) : (
                                                    <p className="empty-text">Wishlist is empty</p>
                                                )}

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <Footer />
            </div>
        </div>
    );
};

export default Wishlist;



// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import Header from "../components/Header";
// import Footer from "../components/Footer";
// import { API_BASE_URL } from "../config";

// const Wishlist = () => {
//     const storedUser = JSON.parse(localStorage.getItem("user") || "{}");
//     const userId = storedUser?.userId || 0;
//     const companyId = storedUser?.companyId || 0;

//     const [wishlist, setWishlist] = useState([]);
//     const navigate = useNavigate();

//     // ==========================
//     // LOAD WISHLIST
//     // ==========================
//     const loadWishlist = async () => {
//         if (!userId) return;

//         try {
//             const res = await fetch(
//                 `${API_BASE_URL}/order/GetWishlist?userId=${userId}&CompanyId=${companyId}`
//             );
//             const data = await res.json();
//             setWishlist(Array.isArray(data) ? data : []);
//         } catch (err) {
//             console.error("Failed to load wishlist", err);
//         }
//     };

//     useEffect(() => {
//         loadWishlist();
//     }, []);

//     // ==========================
//     // REMOVE WISHLIST (WishlistID only)
//     // ==========================
//     const removeWishlist = async (wishlistId) => {
//         try {
//             await fetch(
//                 `${API_BASE_URL}/order/RemoveWishlist?WishlistID=${wishlistId}`,
//                 { method: "DELETE" }
//             );

//             setWishlist((prev) =>
//                 prev.filter((item) => item.wishlistID !== wishlistId)
//             );
//         } catch (err) {
//             console.error("Remove wishlist failed", err);
//         }
//     };

//     return (
//         <div className="home">
//             <div id="page" className="hfeed page-wrapper">
//                 <Header />

//                 <div id="site-main" className="site-main">
//                     <div id="main-content" className="main-content">
//                         <div id="primary" className="content-area">

//                             {/* PAGE TITLE */}
//                             <div
//                                 id="title"
//                                 className="page-title"
//                                 style={{ background: "none", padding: "100px 0" }}
//                             >
//                                 <div className="section-container">
//                                     <div className="content-title-heading">
//                                         <h1 className="text-title-heading">Wishlist</h1>
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* CONTENT */}
//                             <div
//                                 id="content"
//                                 className="site-content"
//                                 role="main"
//                                 style={{ paddingBottom: "100px" }}
//                             >
//                                 <div className="section-padding">
//                                     <div className="section-container p-l-r">
//                                         <div className="shop-wishlist">
//                                             <div className="wishlist-cards">

//                                                 {wishlist.length > 0 ? (
//                                                     wishlist.map((item) => {
//                                                         const metal = item.metalName || "";
//                                                         const shape = item.shape || "";

//                                                         return (
//                                                             <div
//                                                                 key={item.wishlistID}
//                                                                 className="wishlist-card"
//                                                             >
//                                                                 {/* REMOVE */}
//                                                                 <button
//                                                                     className="remove-btn"
//                                                                     onClick={() =>
//                                                                         removeWishlist(item.wishlistID)
//                                                                     }
//                                                                 >
//                                                                     ❌
//                                                                 </button>

//                                                                 {/* IMAGE */}
//                                                                 <img
//                                                                     src={item.productImage}
//                                                                     className="wishlist-img"
//                                                                     alt={item.productName}
//                                                                 />

//                                                                 {/* INFO */}
//                                                                 <div className="wishlist-info">
//                                                                     <h2>{item.productName}</h2>

//                                                                     <p className="price">
//                                                                         {item.metalName}

//                                                                     </p>
//                                                                     <p className="price">
//                                                                         {item.shape}

//                                                                     </p>
//                                                                     {/* VIEW */}
//                                                                     <button
//                                                                         className="view-btn"
//                                                                         onClick={() =>
//                                                                             navigate(
//                                                                                 `/productdetails/${item.productID}?metal=${encodeURIComponent(
//                                                                                     metal
//                                                                                 )}${shape
//                                                                                     ? `&shape=${encodeURIComponent(
//                                                                                         shape
//                                                                                     )}`
//                                                                                     : ""
//                                                                                 }`
//                                                                             )
//                                                                         }
//                                                                     >
//                                                                         View
//                                                                     </button>
//                                                                 </div>
//                                                             </div>
//                                                         );
//                                                     })
//                                                 ) : (
//                                                     <p className="empty-text">Wishlist is empty</p>
//                                                 )}

//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>

//                         </div>
//                     </div>
//                 </div>

//                 <Footer />
//             </div>
//         </div>
//     );
// };

// export default Wishlist;
